// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__18ULb","item":"PaymentsMobile_item__130eb","label":"PaymentsMobile_label__3sA3J","amount":"PaymentsMobile_amount__2wsUk"};